declare module '@mui/material/styles' {
  interface BreakpointOverrides {
    xs: true
    sm: true
    md: true
    lg: true
    xl: true
    xxl: true
    xxxl: true
    // mobile: true // adds the `mobile` breakpoint
    // tablet: true
    // laptop: true
    // desktop: true
  }
}

const breakpoints = {
  values: {
    xs: 0,
    sm: 380,
    md: 600,
    lg: 900,
    xl: 1120,
    xxl: 1440,
    xxxl: 1920,
  },
}

export default breakpoints
